export const TARGET_GEO_LEVEL = { CITY: 'city', COUNTRY: 'country' } as const;
